import React from 'react';
import styled from 'styled-components';
import withPageEntry from '../../withPageEntry';
import * as AppActions from '../../AppActions';
import * as JStorage from '../../JStorage';
import qs from 'query-string';
import Theme from '../../Theme';
import {useOutlet} from 'reconnect.js';
import Breadcrumb from '../../Components/Breadcrumb';

function About(props) {
  const [about] = useOutlet('about');

  return (
    <Wrapper>
      <div className="tda-header">
        <h2>本會簡介</h2>
        <Breadcrumb third="本會簡介" />
      </div>
      <div className="content">
        <span className="first-two-word">
          {about?.introduction.slice(0, 2)}
        </span>
        {about?.introduction.slice(2)}
      </div>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  .content {
    white-space: break-spaces;
    & > .first-two-word {
      font-size: 30px;
      color: var(--primaryColor);
    }
  }
`;

export default withPageEntry(About);
